import { combineReducers } from "redux"

import additionalServices from "mmb/scenes/AccountBooking/components/Booking/services/additionalServices/index"
import alternativeFlights from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingJourneyChange/services/AlternativeFlightsDuck"
import booking from "mmb/scenes/AccountBooking/components/Booking/services"
import bookingInsurance from "mmb/scenes/AccountBooking/components/Booking/services/bookingInsurance/index"
import bookingPayment from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingPayment/services/index"
import bookingSeating from "mmb/scenes/AccountBooking/components/Booking/services/bookingSeating/index"
import changeFlights from "mmb/scenes/AccountBooking/components/Booking/services/changeFlights/index"
import pendingAdditionalServices from "mmb/scenes/AccountBooking/components/Booking/services/pendingAdditionalServices/index"
import plainSearchForm from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingJourneyChange/services/PlainSearchFormDuck"
import bookingRefund from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingRefund/services/BookingRefundDuck"
import bookingCompletion from "mmb/scenes/AccountBooking/components/Booking/components/BookingCheckIn/scenes/BookingCompletion/services/BookingCompletionDuck"
import scheduleChanges from "mmb/scenes/AccountBooking/components/Booking/services/scheduleChanges/index"
import passengerEdit from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingPassengerEdit/services/PassengerEditDuck"
import bookingMeals from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingMeals/services/BookingMealsDuck"
import bookingCancellation from "mmb/scenes/AccountBooking/components/Booking/scenes/UnconfirmedBookingCancellation/services/BookingCancellationDuck"
import passengerAta from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingPassengerAta/services/PassengerAtaDuck"
import ancillaries from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingAncillary/services/BookingAncillaryDuck"
import defaultReducer from "common/services/index"
import bookingBaggage from "mmb/scenes/AccountBooking/components/Booking/scenes/BookingAddBags/services/reducer"

export const mmbReducers = {
  additionalServices,
  alternativeFlights,
  booking,
  bookingCancellation,
  bookingCompletion,
  bookingInsurance,
  bookingPayment,
  bookingRefund,
  bookingSeating,
  bookingMeals,
  changeFlights,
  passengerEdit,
  pendingAdditionalServices,
  plainSearchForm,
  scheduleChanges,
  passengerAta,
  ancillaries,
  bookingBaggage,
}
const mmbReducer = combineReducers({ ...defaultReducer, ...mmbReducers })

export default mmbReducer
